import { useState } from "react";
import "../../crawler/crawler.css";
import axios from "axios";
import toast from "react-hot-toast";
import moment from "moment";
import SwitchButton from "../../../components/commons/SwitchBtn";
import mainAxios from "../../../redux/api/mainAxios";

const CrawlerBody = ({ crawler, setCrawler, search, setSearch }) => {
  const [syncLoading, setSyncLoading] = useState(false);
  const token = localStorage.getItem("token");

  const handleToggle = (itemId, newStatus) => {
    setCrawler((prevCrawler) => ({
      ...prevCrawler,
      data: prevCrawler.data.map((item) =>
        item.documentId === itemId ? { ...item, actif: newStatus } : item
      ),
    }));
  };
  const syncGridkyData = async (documentId) => {
    setSyncLoading(true);
    try {
      toast.success("Démarrage de la synchronisation des données");
      // Capture the current time
      const currentTime = moment().toISOString();

      // Update the lastSync field
      await mainAxios.put(`api/api-listes/${documentId}`, {
        data: {
          lastSync: currentTime,
        },
      });
      const response = await mainAxios.get(`api/sync-gridky-data`);
      setSyncLoading(false);
      toast.success("Synchronisation des données terminée");
    } catch (error) {
      console.error("Error syncing data:", error);
      toast.error("Erreur lors de la synchronisation des données");
      setSyncLoading(false);
    }
  };
  const filteredCrawlerList = crawler?.data?.filter((item) =>
    item.name.toLowerCase().includes(search.toLowerCase())
  );
  console.log("filteredCrawlerList", filteredCrawlerList);
  return (
    <div>
      {/* Header */}
      <div className="crawler-table-header pink text-center">
        {[
          "Nom",
          "Activation",
          "Token",
          "Création",
          "Dernière mise à jour",
          "Actions",
        ].map((header, index) => (
          <div key={index} className="table-cell pink semibold">
            {header}
          </div>
        ))}
      </div>
      {/* Body */}
      <div className="crawler-table-body">
        {filteredCrawlerList && filteredCrawlerList.length > 0 ? (
          filteredCrawlerList.map((item, index) => (
            <div key={index} className="crawler-row">
              <div className="text-center semibold fs16 darkGrey">
                {item.name}
              </div>
              <SwitchButton
                isActive={item.actif}
                itemId={item.documentId}
                fieldName="actif"
                onToggle={(newStatus) =>
                  handleToggle(item.documentId, newStatus)
                }
              />
              <div className="text-center semibold fs16 darkGrey text-truncate mw-100">
                {item.token}
              </div>
              <div className="text-center semibold fs16 darkGrey">
                {moment(item.createdAt).format("DD/MM/YYYY HH:mm:ss")}
              </div>
              <div className="text-center semibold fs16 darkGrey">
                {moment(item.lastSync).format("DD/MM/YYYY HH:mm:ss")}
              </div>
              <div className="table-cell">
                <button
                  className={
                    item.actif && !syncLoading && !item.sync_Ongoing
                      ? "radius5 px-20 py-10 bg-pink text-white border-0"
                      : "radius5 px-20 py-10 bg-soft-grey text-white border-0 pointer-none"
                  }
                  disabled={
                    !item.actif || syncLoading || item.sync_Ongoing === true
                  }
                  onClick={() => syncGridkyData(item.documentId)}
                >
                  Synchroniser
                </button>
              </div>
            </div>
          ))
        ) : (
          <div className="d-flex justify-content-center align-items-center">
            Pas de crawlers
          </div>
        )}
      </div>
    </div>
  );
};

export default CrawlerBody;
